import { UseFormSetValue, UseFormWatch } from "react-hook-form";

import { ERROR_TYPE, translateError } from "@/utils";

import CompanyBalanceSelectorItem from "./CompanyBalanceSelectorItem";

interface CompanyBalanceSelectorFactoryProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	watch: UseFormWatch<any>;
	companyBalances: { id: number; value: string }[];
	error?: string;
	containerClassName?: string;
}

export default function CompanyBalanceSelectorFactory({
	setValue,
	watch,
	companyBalances,
	error,
	containerClassName = "",
}: CompanyBalanceSelectorFactoryProps) {
	const selectedCompanyBalances = watch("companyBalanceIds");

	return (
		<div className={`space-y-1 mb-4 w-full relative ${containerClassName}`}>
			<CompanyBalanceSelectorItem
				companyBalances={companyBalances}
				error={error}
				fieldName="companyBalanceIds"
				setValue={setValue}
				value={selectedCompanyBalances}
			/>
			{error && (
				<p className="absolute -bottom-5 text-[12px] text-danger">
					{translateError[error as ERROR_TYPE] ?? error}
				</p>
			)}
		</div>
	);
}
